import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import Image from 'components/shared/Image'
import RatingNumber from 'components/VDP/RatingNumber'
import GoogleMyBussinesIcon from 'public/img/google-my-bussines.png'
import sx from './styles'

const RatingCardRow = (props) => {
  const {
    rating = 0,
    text,
    sx: sxProp,
    showSeeMore = false,
    handleModal,
    showGoogleMapIcon = false,
    showGoogleMyBussinesIcon = false,
  } = props

  return (
    <Box
      sx={{ ...sx.root, ...sxProp }}
      className="RatingRow-root"
    >
      <Grid
        container
        alignItems="center"
        sx={sx.container}
      >
        <Grid>
          <Grid
            container
            justifyContent="space-between"
            sx={sx.container}
          >
            <Grid
              size="auto"
            >
              <RatingNumber rating={rating} />
            </Grid>
            <Grid
              size="auto"
              sx={{ p: 0.5 }}
            >
              {showGoogleMyBussinesIcon && (
                // <GoogleMyBussinesIcon />
                <Image
                  sx={sx.iconMaps}
                  src={GoogleMyBussinesIcon}
                  alt="image"
                  width={70}
                  height={30}
                />
              )}
            </Grid>
            <Grid size="auto">
              {showGoogleMapIcon && (
                <Image
                  sx={sx.iconMaps}
                  src="/img/googleMapsIcon.png"
                  alt="image"
                  width={26}
                  height={24}
                />
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid size="grow">
          <Typography
            variant="caption"
            component="p"
            sx={sx.caption}
          >
            {text}
            {showSeeMore && (
              <Typography
                variant="link-text"
                component="span"
                sx={sx.seeMore}
                onClick={handleModal}
              >
                <FormattedMessage id="SEE_MORE" />
              </Typography>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

export default memo(RatingCardRow)
